import "./footer.css";

const Footer = () => {
    return (
        <div>
            <div className="footer">
                <p>Developed by Harshit Gulati, Karanveer Singh & Pranav Mahajan for Ideathon 2023.</p>
            </div>
        </div>
    );
}

export default Footer;
